import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.564 16.174.002.002A1 1 0 0 1 21 18H3a1 1 0 0 1-.566-1.824l.003-.002.052-.042c.053-.044.141-.123.254-.242.224-.237.547-.636.88-1.244C4.282 13.435 5 11.353 5 8a7 7 0 0 1 14 0c0 3.353.717 5.435 1.378 6.646.332.608.655 1.007.88 1.244a3 3 0 0 0 .306.284m-13.1-11.71A5 5 0 0 1 17 8c0 3.647.783 6.065 1.622 7.604q.114.21.229.396H5.149a10 10 0 0 0 .229-.396C6.218 14.065 7 11.647 7 8a5 5 0 0 1 1.465-3.536ZM11.176 20.518a1 1 0 1 0-1.752.964 2.94 2.94 0 0 0 5.152 0 1 1 0 0 0-1.752-.964.94.94 0 0 1-1.648 0"
    }, null, -1)
  ]))]))
}
export default { render: render }